const DATA_TEST_IDS = {
  fragmentsCheckAccountFragment:
    'authentication__recovery_check-account-fragment',
} as const;

export default DATA_TEST_IDS;
